import { useContext } from 'react'

import { context } from './context'

/** Helper context to provide form global settings to underlying fields. */
export const useFormOptions = () => {
	const formOptionsContext = useContext(context)

	if (!formOptionsContext) {
		throw new Error('@subaio/components HookForm: No provider used, useFormOptions must be used within a Form')
	}

	return formOptionsContext
}
